import React from 'react';

/** Página de soporte pública (para App Store "Support URL"). Ruta /soporte. */
export const Soporte: React.FC = () => {
  return (
    <div style={{ maxWidth: 760, margin: '40px auto', padding: '0 20px', color: '#0A0A0A', lineHeight: 1.6, fontFamily: '-apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif' }}>
      <h1 style={{ fontSize: '1.8rem' }}>Soporte — DashFlow</h1>
      <p style={{ color: '#51606E' }}>DashFlow es una app de gestión de inventario y ventas para comercios.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>¿Necesitás ayuda?</h2>
      <p>Si tenés alguna duda, encontrás un problema o querés sugerir una mejora, escribinos por correo y te ayudamos.</p>
      <p>
        Contacto: <a href="mailto:eric.frick@efcloud.tech" style={{ color: '#384DF4' }}>eric.frick@efcloud.tech</a>
      </p>
      <p>Respondemos dentro de las 48 horas.</p>

      <p style={{ marginTop: '2rem' }}>
        También podés leer nuestra <a href="/privacidad" style={{ color: '#384DF4' }}>Política de Privacidad</a>.
      </p>
    </div>
  );
};

export default Soporte;
